import React, { useEffect, useRef, useState } from "react";
import {
    Image,
    ImageFit,
    IconButton
} from "@fluentui/react";

interface PhotoSlideshowProps {
    photos: string[];
    aspectRatio: number;
    interval?: number;
}

const PhotoSlideshow: React.FC<PhotoSlideshowProps> = ({
    photos,
    aspectRatio,
    interval = 3000
}) => {
    const [index, setIndex] = useState(0);

    const touchStartX = useRef<number | null>(null);
    const touchEndX = useRef<number | null>(null);

    const next = () => {
        setIndex(current =>
            (current + 1) % photos.length
        );
    };

    const previous = () => {
        setIndex(current =>
            current === 0 ? photos.length - 1 : current - 1
        );
    };

    // Auto slide
    useEffect(() => {
        if (photos.length <= 1) {
            return;
        }

        const timer = setInterval(() => {
            setIndex(current =>
                (current + 1) % photos.length
            );
        }, interval);

        return () => clearInterval(timer);
    }, [photos.length, interval]);

    const onTouchStart = (
        event: React.TouchEvent<HTMLDivElement>
    ) => {
        touchEndX.current = null;
        touchStartX.current = event.targetTouches[0].clientX;
    };

    const onTouchMove = (
        event: React.TouchEvent<HTMLDivElement>
    ) => {
        touchEndX.current = event.targetTouches[0].clientX;
    };

    const onTouchEnd = () => {
        if (
            touchStartX.current === null ||
            touchEndX.current === null
        ) {
            return;
        }

        const distance =
            touchStartX.current - touchEndX.current;

        const minSwipeDistance = 50;

        if (distance > minSwipeDistance) {
            // Swipe left
            next();
        }

        if (distance < -minSwipeDistance) {
            // Swipe right
            previous();
        }

        touchStartX.current = null;
        touchEndX.current = null;
    };

    if (photos.length === 0) {
        return null;
    }

    return (
        <div
            className={"photo-slideshow"}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
            style={{ aspectRatio: aspectRatio }}
        >
            {/*<Image*/}
            {/*    src={photos[index]}*/}
            {/*    imageFit={ImageFit.contain}*/}
            {/*    width="100%"*/}
            {/*    height="100%"*/}
            {/*    draggable={false}*/}
            {/*/>*/}

            <div className="slides">
                {photos.map((photo, photoIndex) => (
                    <div
                        key={photo}
                        className={
                            photoIndex === index
                                ? "slide-wrapper active"
                                : "slide-wrapper"
                        }
                    >
                        <Image
                            src={photo}
                            imageFit={ImageFit.contain}
                            draggable={false}
                            width="100%"
                            height="100%"
                        />
                    </div>
                ))}
            </div>

            <IconButton
                iconProps={{ iconName: "ChevronLeft" }}
                className="slide-button slide-left"
                onClick={previous}
            />

            <IconButton
                iconProps={{ iconName: "ChevronRight" }}
                className="slide-button slide-right"
                onClick={next}
            />

            <div className="slide-counter">
                {index + 1} / {photos.length}
            </div>
        </div>
    );
};

export default PhotoSlideshow;